<template>
  <v-flex>
    <div class="p-t-20">
      <div class="tituloBox border-top">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Sócios</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="headers"
      :items="habilitacaoLista.sociosLista"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        
        <td nowrap class="text-center">
          <v-tooltip top>
            <v-icon @click="editarItem(props.item)" color="blue" class="mx-1" slot="activator">edit</v-icon>
            <span>Editar</span>
          </v-tooltip>
          <v-icon @click="deleteItem(props.item)" class="mx-1">delete</v-icon>
        </td>
        <td class="text-xs-left" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}">
          {{ props.item.nome }}
        </td>
        <td class="text-xs-left" v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico}">
          <input
            v-if="(props.item.flagEstrangeiro) == 0"
            v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
            readonly
            :value="props.item.cpfCnpj"
          />
          <input
            v-else
            v-mask="maskDocumentoIdentificacao"
            readonly
            :value="props.item.cpfCnpj"
          />
        </td>
        <td class="text-xs-center" v-bind:class="{'cpf-servidor' : props.item.isFuncionarioPublico}">
          {{ props.item.isFuncionarioPublico ? "Sim" : "Não" }}
        </td>
        <td class="text-xs-center" v-bind:class="{'cpf-servidor': props.item.isFuncionarioPublico}">
          {{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}
        </td>
        <td class="text-xs-center" v-bind:class="{'cpf-servidor' : props.item.isFuncionarioPublico}">
          {{ String(props.item.percentual).replace(".",",") }}
        </td>
        <td class="text-xs-center">
          <a @click="baixarArquivo(props.item.arquivoUpload)">{{subStrUpload(props.item.arquivoUpload,$t("label.anexo"))}}</a>
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>


<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "socios-crud",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    habilitacaoLista: Object,
    erroHabilitacaoJuridica:Object
  },
  data() {//Declaracao de variaveis
    return {
      crud: false,
      totalDesserts: 0,
      loading: false,
      headers: [ /*Cabeçalho da data-table*/
        {
          text: "Ações",
          align: "center",
          sortable: false,
          width: 70
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          width: 300
        },
        {
          text: "CPF/CNPJ",
          align: "left",
          sortable: false,
          width: 130
        },
        {
          text: this.$t("label.socioServidor"),
          align: "center",
          sortable: false,
          width: 70
        },
        {
          text: "Brasileiro?",
          align: "center",
          sortable: false,
          width: 70
        },
        {
          text: "Percentual",
          align: "center",
          sortable: false,
          width: 120
        },
        {
          text: "Anexo",
          align: "center",
          sortable: false,
          width: 120
        }
      ]
    };
  },
  methods: {//Declaracao de todos os metodos
    deleteItem(itemLista) {
        //deletar socio
        this.$emit("exclusaoListar","1");

        fornecedorService
          .deleteFornecedorHabilitacaoJuridica(itemLista.idFornecHabilitacaoJur)
          .then(response => { /*resposta do servico*/
            this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/
            this.habilitacaoLista.sociosLista = [];
            this.habilitacaoLista.dirigentesLista = [];

            this.model.fornecedoresHabilitacaoJuridica.filter(item => {
              if (item.tipoCadastro === "D") {
                this.habilitacaoLista.dirigentesLista.push(item);
              } else {
                this.habilitacaoLista.sociosLista.push(item);
              }
            });
            if(!this.habilitacaoLista.sociosLista.length){
                this.erroHabilitacaoJuridica.erro=false;
            }
          });
    },
    editarItem(itemLista) {
      this.$emit("editarItem", itemLista);
    },

    baixarArquivo(arquivo) {
      //baixar arquivo
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g,"");
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
    }
  }
};
</script>